// Brewery behavior is isolated from the published theme's shared accordion.
if(!customElements.get('sakezen-brewery-accordion')){
    class SakezenBreweryAccordion extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }
    
        init(){
            this.text = this.querySelector('.accordion-text');
            this.textInner = this.text.querySelector('.accordion-text__inner');
            this.heading = this.querySelector('.accordion-heading');
            this.remainOpen = this.getAttribute('data-remain-open') == 'true'? true : false;
    
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(this.heading){
                this.heading.setAttribute('role', 'button');
                this.heading.setAttribute('aria-expanded', ifOpened ? 'true' : 'false');
            }
            this.text.setAttribute('aria-hidden', ifOpened ? 'false' : 'true');
            this.text.toggleAttribute('inert', !ifOpened);
            if(ifOpened){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + 2rem)`;
            }else{
                this.textHeight = 0;
                this.text.style.height = `${this.textHeight}px`;
            }
    
            this.resizeObserver = new ResizeObserver(() => {
                if(this.getAttribute('data-open') === 'true') this.setAccordionTextHeight(true);
            });
            this.resizeObserver.observe(this.textInner);

            this.addEventListener('click', this.openAccordion.bind(this));
            this.addEventListener('keydown', e => {
                const heading = e.target.classList.contains('accordion-heading')
                    ? e.target
                    : e.target.closest('.accordion-heading');

                if(!heading || e.repeat || (e.key !== 'Enter' && e.key !== ' ')) return;

                e.preventDefault();
                this.openAccordion(e);
            })
        }
    
        openAccordion(e){
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(ifOpened && (!this.remainOpen || e.target.classList.contains('accordion-heading') || e.target.closest('.accordion-heading'))){ 
                // close the accordion
                this.setAttribute('data-open', 'false');
                if(this.heading) this.heading.setAttribute('aria-expanded', 'false');
                this.text.setAttribute('aria-hidden', 'true');
                this.text.setAttribute('inert', '');
                this.setAccordionTextHeight();
            }else{
                // open accordion
                this.setAttribute('data-open', 'true');
                if(this.heading) this.heading.setAttribute('aria-expanded', 'true');
                this.text.setAttribute('aria-hidden', 'false');
                this.text.removeAttribute('inert');
                this.setAccordionTextHeight(true);
            }
        }
    
        disconnectedCallback(){
            if(this.resizeObserver) this.resizeObserver.disconnect();
        }

        connectedCallback(){
            if(this.resizeObserver && this.textInner) this.resizeObserver.observe(this.textInner);
        }

        closeAccordion(){
            this.setAttribute('data-open', 'false');
            if(this.heading) this.heading.setAttribute('aria-expanded', 'false');
            this.text.setAttribute('aria-hidden', 'true');
            this.text.setAttribute('inert', '');
            this.setAccordionTextHeight();
        }
    
        setAccordionTextHeight(open = false){
            if(open){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + 2rem)`;
                return;
            }
    
            this.textHeight = 0;
            this.text.style.height = `${this.textHeight}px`;
        }
    }
    
    customElements.define('sakezen-brewery-accordion', SakezenBreweryAccordion);    

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-brewery-trigger]');
  if (!trigger) return;

  const targetId = trigger.getAttribute('aria-controls');
  const accordion = targetId ? document.getElementById(targetId) : null;
  const heading = accordion?.querySelector('.accordion-heading');
  if (!accordion || !heading) return;

  event.preventDefault();

  const shouldMoveFocus = trigger.matches(':focus-visible');
  const wasClosed = accordion.getAttribute('data-open') !== 'true';
  const content = accordion.querySelector('.accordion-text');
  const getVisibleHeaderOffset = () => {
    const headerCandidates = document.querySelectorAll(
      'custom-header, .header-wrapper, [data-section-type="header"], header, [class*="announcement"], .fixed-top, .position-fixed'
    );
    let scrollOffset = 0;

    headerCandidates.forEach((element) => {
      const styles = window.getComputedStyle(element);
      const bounds = element.getBoundingClientRect();
      const isVisible = styles.display !== 'none' && styles.visibility !== 'hidden';
      const isReasonableHeaderHeight = bounds.height > 0 && bounds.height < window.innerHeight * 0.5;
      const isKnownSiteHeader =
        element.matches('custom-header') &&
        bounds.top >= 0 &&
        bounds.top < window.innerHeight * 0.25;
      const isGenericHeaderAtViewportTop =
        element.matches('header') && bounds.top <= 1 && bounds.bottom > 0;
      const isSiteHeader = isKnownSiteHeader || isGenericHeaderAtViewportTop;

      if (isVisible && isReasonableHeaderHeight && isSiteHeader) {
        const currentlyInDocumentFlow = styles.position === 'static' || styles.position === 'relative';
        // At the page top, the header still occupies layout space. Once fixed, account for both
        // its removal from the document flow and the space it overlays above the target heading.
        const fixedHeaderOffset = bounds.height * (currentlyInDocumentFlow ? 2 : 1);
        scrollOffset = Math.max(scrollOffset, fixedHeaderOffset);
        return;
      }

      if (
        (styles.position !== 'fixed' && styles.position !== 'sticky') ||
        bounds.top > 1 ||
        bounds.bottom <= 0
      ) return;

      const coversViewportTop = bounds.top <= 1 && bounds.bottom > 0;

      if (isVisible && coversViewportTop && isReasonableHeaderHeight) {
        scrollOffset = Math.max(scrollOffset, bounds.bottom);
      }
    });

    return Math.max(24, scrollOffset + 24);
  };
  const scrollToHeading = () => {
    const targetTop = window.scrollY + heading.getBoundingClientRect().top - getVisibleHeaderOffset();

    window.scrollTo({ top: targetTop, behavior: 'instant' });
  };
  const finishNavigation = () => {
    if (shouldMoveFocus && document.activeElement === trigger) {
      heading.focus({ preventScroll: true });
    }

    scrollToHeading();
  };

  if (wasClosed) {
    const previousInlineTransition = content?.style.transition;
    if (content) content.style.transition = 'none';

    heading.click();

    if (content) {
      content.getBoundingClientRect();
      content.style.transition = previousInlineTransition;
    }
  }

  finishNavigation();
});

}
